import React, { useCallback, useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { AppNavContext } from '../context/AppNavContext';
import { useLocation } from 'react-router-dom';
import TicketButton from './TicketButton';
import { isTicketAdmin } from '../utils/ticketAdmin';
import { useApprovers } from '../utils/approverStore';

/**
 * Layout wrapper that shows the floating ticket button on authenticated routes
 * that have no navigation sidebar (the sidebar carries its own Support item).
 */
const AppLayout = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [navCount, setNavCount] = useState(0);
  // Approvers see the ticket queue; re-render once the chain has loaded.
  useApprovers(Boolean(user));

  const registerNav = useCallback(() => {
    setNavCount((count) => count + 1);
    return () => setNavCount((count) => count - 1);
  }, []);
  const navValue = useMemo(() => ({ registerNav }), [registerNav]);

  // Define routes where ticket button should NOT appear
  const excludedRoutes = ['/login', '/register', '/forgot-password', '/'];

  // Check if current route is excluded, a client portal route, or form-expired page
  const isClientPortalRoute = location.pathname.startsWith('/client-portal');
  const isFormExpiredRoute = location.pathname === '/form-expired' || location.pathname === '/form-preview';
  const shouldShowTicket =
    user && !excludedRoutes.includes(location.pathname) && !isClientPortalRoute && !isFormExpiredRoute;

  return (
    <AppNavContext.Provider value={navValue}>
      {children}
      {shouldShowTicket && navCount === 0 && <TicketButton userEmail={user.email} isAdmin={isTicketAdmin(user.email)} />}
    </AppNavContext.Provider>
  );
};

export default AppLayout;
